import React from 'react';

import { Partner } from 'src/reducers/partner/types';

import { getTranslation } from 'Utilities/dataHelpers';

import { PARTNER_TYPES } from 'Constants/partnerTypes';

import LoadingButton from 'Components/loading/LoadingButton';

import linkArrowImg from 'Images/link-arrow.svg';

import styles from './PartnerListItem.module.scss';

interface PartnerProps {
  connectAction: string;
  id: string;
  partnerData: Partner;
  running?: string;
  setRunning?: React.Dispatch<React.SetStateAction<string>>;
}

const PartnerListItem: React.FC<React.PropsWithChildren<PartnerProps>> = ({
  connectAction,
  id,
  partnerData,
  running,
  setRunning,
}) => {
  const name = partnerData.name;
  let description = <span id="otherConnectionsDesc-text">{name}</span>;

  switch (partnerData.type) {
    case PARTNER_TYPES.API:
    case PARTNER_TYPES.COMMERCIAL_API:
    case PARTNER_TYPES.INBOUND:
      description = (
        <span id="otherConnectionsDesc-text">
          {getTranslation(partnerData.translations, 'blurb')}
        </span>
      );
      break;
  }

  return (
    <div
      id={`otherConnections-${id}`}
      className={`d-flex flex-column pb-2 ${styles.partnerListItem}`}
    >
      <div className="d-flex justify-content-between align-items-center no-gutters mb-2">
        <span id="otherConnectionsLogo-text" className={styles.brandTitle}>
          {name}
        </span>

        <LoadingButton
          id={'otherConnectionsAction-btn'}
          className={'btn flex-shrink-0 font-weight-bold ml-3'}
          href={connectAction}
          onClick={() => {
            setRunning && setRunning(id);
          }}
          running={running === id}
        >
          <img src={linkArrowImg} />
        </LoadingButton>
      </div>

      {description}
    </div>
  );
};

export default PartnerListItem;
